import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ProductItems } from 'app/models/product/get-product-request';
import { throttleTime, filter, pairwise, map } from 'rxjs/operators';

import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { StoreService } from 'app/services';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'product-grid-view',
  templateUrl: './grid-view.component.html',
  styleUrl: './grid-view.component.scss',
})
export class ProductGridViewComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges, AfterViewChecked
{
  @Output() delete = new EventEmitter<string>();
  @Output() loadProducts = new EventEmitter<null>();
  @Output() editProduct = new EventEmitter<ProductItems>();
  @Output() viewProduct = new EventEmitter<ProductItems>();

  @Input() productItems = new Array<ProductItems>();

  @ViewChild('scroller') scroller!: CdkVirtualScrollViewport;

  selectedProduct: ProductItems | null = null;

  constructor(private ngZone: NgZone, private storeService: StoreService, private messageService: MessageService) { }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {

  }

  ngAfterViewChecked(): void {}

  ngAfterViewInit() {
    this.scroller
      .elementScrolled()
      .pipe(
        map(() => this.scroller.measureScrollOffset('bottom')),
        pairwise(),
        filter(([y1, y2]) => y2 < y1 && y2 < 140),
        throttleTime(300)
      )
      .subscribe(() => {
        this.ngZone.run(() => {
          this.loadProducts.emit(null);
        });
      });
  }

  removeProduct(productItemId: number) {
    const dto = {
      Id: productItemId,
    };

    this.storeService.deleteProductItem(dto, this.messageService)
        .then(data => {

          if (!data) {
            return;
          }

          if (!data.Success) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
            return;
          }

          // Remove productItem from the array
          const productIndex = this.productItems.findIndex(product => product.Id === productItemId);
          if (productIndex > -1) {
            this.productItems.splice(productIndex, 1);
            // Create a new array reference to trigger change detection
            this.productItems = [...this.productItems];
          }

          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Product removed successfully.' });
        })
        .catch(error => {
          console.error('Error:', error);
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Unable to remove product. Please try again.' });
          throw error;
        });
  }

  ngOnDestroy() {}

  setSelectedProduct(product: ProductItems): void {
    this.selectedProduct = product;
  }

  onEditProduct(product: ProductItems | null): void {
    if (product) {
      this.editProduct.emit(product);
    }
  }

  onViewProduct(product: ProductItems | null): void {
    if (product) {
      this.viewProduct.emit(product);
    }
  }

  onDeleteProduct(product: ProductItems | null): void {
    if (product) {
      this.delete.emit(product.Id.toString());
    }
  }
}
